import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { ChevronLeft, ChevronRight } from 'lucide-vue-next';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Pagination',
    props: {
        currentPage: { type: Number, required: true },
        lastPage: { type: Number, required: true },
        total: { type: Number, required: true },
        perPage: { type: Number, required: true },
        perPageOptions: { type: Array, required: false, default: () => [10, 25, 50, 100] },
        itemName: { type: String, required: false, default: 'items' },
        dataTrack: { type: String, required: false }
    },
    emits: ["page-change", "update:perPage"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const showingFrom = computed(() => {
            if (props.total === 0)
                return 0;
            return (props.currentPage - 1) * props.perPage + 1;
        });
        const showingTo = computed(() => {
            return Math.min(props.currentPage * props.perPage, props.total);
        });
        // Page pagination item descriptor to avoid string comparison bugs
        const visiblePages = computed(() => {
            const pageItems = [];
            const currentPageNumber = props.currentPage;
            const totalPagesCount = props.lastPage;
            // Helper to generate a standardized page item matching { type: 'page'; value: number }
            const createPageItem = (pageNumber) => ({
                type: 'page',
                value: pageNumber,
            });
            // Threshold for showing all pages without any truncation/ellipses
            const MAX_PAGES_WITHOUT_TRUNCATION = 7;
            if (totalPagesCount <= MAX_PAGES_WITHOUT_TRUNCATION) {
                for (let page = 1; page <= totalPagesCount; page++) {
                    pageItems.push(createPageItem(page));
                }
                return pageItems;
            }
            // Always show the first page
            pageItems.push(createPageItem(1));
            // Add left ellipsis if current page is far enough from page 1
            const shouldShowLeftEllipsis = currentPageNumber > 3;
            if (shouldShowLeftEllipsis) {
                pageItems.push({ type: 'ellipsis', id: 'left-ellipsis' });
            }
            // Calculate middle visible window: 1 page before and 1 page after current page
            const windowStartPage = Math.max(2, currentPageNumber - 1);
            const windowEndPage = Math.min(totalPagesCount - 1, currentPageNumber + 1);
            for (let page = windowStartPage; page <= windowEndPage; page++) {
                pageItems.push(createPageItem(page));
            }
            // Add right ellipsis if current page is far enough from the last page
            const shouldShowRightEllipsis = currentPageNumber < totalPagesCount - 2;
            if (shouldShowRightEllipsis) {
                pageItems.push({ type: 'ellipsis', id: 'right-ellipsis' });
            }
            // Always show the last page
            pageItems.push(createPageItem(totalPagesCount));
            return pageItems;
        });
        const handlePerPageChange = (event) => {
            const target = event.target;
            if (target) {
                emit('update:perPage', Number(target.value));
            }
        };
        const __returned__ = { props, emit, showingFrom, showingTo, visiblePages, handlePerPageChange, get ChevronLeft() { return ChevronLeft; }, get ChevronRight() { return ChevronRight; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
